import { render } from "./LotteryPage.vue?vue&type=template&id=44b8bbe1&bindings={}"
import script from "./LotteryPage.vue?vue&type=script&lang=ts"
export * from "./LotteryPage.vue?vue&type=script&lang=ts"

import "./LotteryPage.vue?vue&type=style&index=0&lang=less"
script.render = render

export default script